import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TermsOfServicePage.css';

const logoUrl = `${process.env.PUBLIC_URL || ''}/logo.png`;

function TermsOfServicePage() {
  return (
    <div className="legal-page terms-of-service-page">
      <header className="legal-page-header">
        <div className="legal-page-logo">
          <Link to="/" aria-label="Frame-Book Home">
            {logoUrl && <img src={logoUrl} alt="Frame-Book" className="legal-page-logo-img" />}
          </Link>
        </div>
        <h1 className="legal-page-title">Terms of Service</h1>
        <Link to="/" className="legal-page-back">
          Back to home
        </Link>
      </header>
      <div className="legal-page-content">
        <iframe
          src="/documents/Frame-Book_Terms_StructureBased_v4.pdf#toolbar=0"
          title="Terms of Service"
          className="legal-page-iframe"
        />
        <p className="legal-page-fallback">
          <a href="/documents/Frame-Book_Terms_StructureBased_v4.pdf" target="_blank" rel="noopener noreferrer">
            Open Terms of Service (PDF) in new tab
          </a>
        </p>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
